import { UserRoleType } from 'shared/types';
import { getText } from '../../../../../shared/text';

const {
  settings: { user },
} = getText('EN');

export type RoleType = { id: UserRoleType; name: string };

export const USERS_PER_PAGE = 10;

export const roles: RoleType[] = [
  {
    id: 'ADMIN',
    name: user.fields?.roleAdmin?.name || '',
  },
  {
    id: 'ANALYST',
    name: user.fields?.roleAnalyst?.name || '',
  },
  {
    id: 'OWNER',
    name: user.fields?.roleOwner?.name || '',
  },
  {
    id: 'VIEWER',
    name: user.fields?.roleViewer?.name || '',
  },
];

export type TabOptionsType = {
  id: string;
  name: string;
};

export const INVITE_ROLES = [
  {
    id: 'ADMIN',
    name: user.fields?.roleAdmin?.name,
    desc: user.fields?.roleAdmin?.hint,
  },
  {
    id: 'ANALYST',
    name: user.fields?.roleAnalyst?.name,
    desc: user.fields?.roleAnalyst?.hint,
  },
  {
    id: 'VIEWER',
    name: user.fields?.roleViewer?.name,
    desc: user.fields?.roleViewer?.hint,
  },
];
